import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Field, Form, Formik } from 'formik';
import { useDispatch } from 'react-redux';
import FormikInput from '../../../../../../CommonComponents/FormikInput';
import Spinner from '../../../../../../CommonComponents/Spinner';
import { PrimaryButton, SecondaryButton } from '../../../../../../CommonComponents/Button';
import { addPassportNumber } from '../../../../../ExperianActions';
import { Footer, Label, LabelText } from '../../../../../components/EnrollForm/EnrollFormStyles';
import { Title } from '../../../ReportStyles';
import ExperianContext from '../../../../../ExperianContext';

const PassportNumberForm = ({ onCancel, onRequestClose }) => {
  const { clientId, subscriberId } = useContext(ExperianContext);

  const dispatch = useDispatch();

  return (
    <Formik
      initialValues={{
        passportNumber: '',
      }}
      onSubmit={async (values, actions) => {
        try {
          await dispatch(addPassportNumber(clientId, subscriberId, values));
          onRequestClose();
          onCancel();
        } catch {
          // Keep the modal open to display the error
        } finally {
          actions.setSubmitting(false);
        }
      }}
      render={({ isSubmitting }) => (
        <Form>
          {isSubmitting && <Spinner />}
          <Title>Monitor Passport Number</Title>
          <Label>
            <LabelText>Passport Number</LabelText>
            <Field type="text" name="passportNumber" component={FormikInput} size="small" />
          </Label>
          <Footer>
            <SecondaryButton onClick={onCancel}>Cancel</SecondaryButton>
            <PrimaryButton type="submit" disabled={isSubmitting}>
              Submit
            </PrimaryButton>
          </Footer>
        </Form>
      )}
    />
  );
};

PassportNumberForm.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onRequestClose: PropTypes.func.isRequired,
};

export default PassportNumberForm;
